import styled from 'styled-components';

export const StatusBadge = styled.span<{ $variant: 'success' | 'danger' | 'secondary' }>`
  display: inline-block;
  padding: 0.2em 0.6em;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: ${({ theme }) => theme.radii.md};
  color: ${({ theme }) => theme.colors.textInverse};
  background-color: ${({ $variant, theme }) =>
    $variant === 'success'
      ? theme.colors.success
      : $variant === 'danger'
        ? theme.colors.danger
        : theme.colors.gray500};
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const EmptyState = styled.p`
  color: ${({ theme }) => theme.colors.gray500};
  font-style: italic;
`;
